import React from 'react';
import { StyleSheet, View } from 'react-native';

import { onboardingTestIDs, Theme } from '@constants';

import { onboardingDebugItems, OnboardingDebugSection } from './OnboardingDebugSection';

import { TWCPage } from '../../primitives/TWCPage/TWCPage';
import { TWCText } from '../../primitives/TWCText/TWCText';

export const OnboardingDebugPage = ({ route }) => {
  const { debugItem } = route.params;

  console.log('onboarding page debug item:');
  console.log(debugItem);
  return (
    <TWCPage
      childIds={onboardingDebugItems.map(item => item.buttonTestID)}
      firstFocus={onboardingTestIDs.onboardingDebugMenu.onboardingHomeButton}
      pageID={debugItem.pageID}
    >
      <View style={styles.pageTitleWrapper}>
        <TWCText noTestID variant={'regularText30'}>
          {'Onboarding Pages'}
        </TWCText>
      </View>
      <OnboardingDebugSection />
    </TWCPage>
  );
};

const styles = StyleSheet.create({
  pageTitleWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: Theme.px(20),
  },
});
